function crossSellHandles() {
    const source = document.querySelector('form[data-type="add-to-cart-form"] input[name="properties[_crosssell]"]');
    return source && source.value ? source.value.trim() : '';
}

// Zepto's popup form is separate from the product form, so Looking for more
// never sees the product's _crosssell list unless we copy it across.
function copyCrossSellOntoPersonalizerForm(form) {
    if (!form || !form.classList || !form.classList.contains('pplr_form')) return;
    const handles = crossSellHandles();
    if (!handles) return;

    let input = form.querySelector('input[name="properties[_crosssell]"]');
    if (!input) {
        input = document.createElement('input');
        input.type = 'hidden';
        input.name = 'properties[_crosssell]';
        form.appendChild(input);
    }
    input.value = handles;
}

function scanPersonalizerForms(root) {
    if (root && root.matches && root.matches('form.pplr_form')) {
        copyCrossSellOntoPersonalizerForm(root);
    }
    const scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll('form.pplr_form').forEach(copyCrossSellOntoPersonalizerForm);
}

document.addEventListener('click', function (e) {
    const btn = e.target.closest && e.target.closest('form.pplr_form button, form.pplr_form input[type="submit"]');
    if (!btn) return;
    copyCrossSellOntoPersonalizerForm(btn.closest('form'));
}, true);

document.addEventListener('submit', function (e) {
    if (!e.target || !e.target.classList || !e.target.classList.contains('pplr_form')) return;
    copyCrossSellOntoPersonalizerForm(e.target);
}, true);

new MutationObserver(function (mutations) {
    mutations.forEach(function (m) {
        (m.addedNodes || []).forEach(function (node) {
            if (node.nodeType === 1) scanPersonalizerForms(node);
        });
    });
}).observe(document.documentElement, { childList: true, subtree: true });

async function ensureCrossSellOnAddedLine(form) {
    const handles = crossSellHandles();
    if (!handles) return;

    const variantInput = form && form.querySelector && form.querySelector('input[name="id"]');
    const variantId = variantInput && variantInput.value;
    if (!variantId) return;

    const cart = await fetch('/cart.js', {
        credentials: 'same-origin',
        headers: { Accept: 'application/json' }
    }).then(function (r) { return r.json(); });

    const targets = (cart.items || []).filter(function (item) {
        if (String(item.variant_id) !== String(variantId)) return false;
        const props = item.properties || {};
        if (props._crosssell) return false;
        const sku = (item.sku || '').toUpperCase();
        return sku !== 'PRS' && sku !== 'PER';
    });

    for (const item of targets) {
        await fetch('/cart/change.js', {
            method: 'POST',
            credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({
                id: item.key,
                quantity: item.quantity,
                properties: Object.assign({}, item.properties, { _crosssell: handles })
            })
        });
    }
}

// The drawer reads _crosssell, renders Looking for more, then deletes that
// property. The next page opens an empty section. Leave the list on the line.
function keepCrossSellOnCartLines() {
    var root = document.querySelector('.right-drawer-vue') || document.querySelector('wetheme-right-drawer');
    if (!root) return;
    var start = root.__vue__ || (root.__vueParentComponent && root.__vueParentComponent.proxy);
    if (!start) return;

    var stack = [start];
    while (stack.length) {
        var vm = stack.pop();
        if (vm && typeof vm.stripCrossSellMetadataFromCart === 'function' && !vm.__rrKeepCrossSell) {
            vm.stripCrossSellMetadataFromCart = function () { return Promise.resolve(); };
            vm.__rrKeepCrossSell = true;
        }
        var kids = (vm && vm.$children) || [];
        for (var i = 0; i < kids.length; i++) stack.push(kids[i]);
    }
}

keepCrossSellOnCartLines();
document.addEventListener('DOMContentLoaded', keepCrossSellOnCartLines);
var keepCrossSellTries = 0;
var keepCrossSellTimer = setInterval(function () {
    keepCrossSellOnCartLines();
    keepCrossSellTries += 1;
    if (keepCrossSellTries >= 20) clearInterval(keepCrossSellTimer);
}, 250);

var CROSS_SELL_STORE = 'rrCrossSellByVariant';

function readCrossSellStore() {
    try {
        return JSON.parse(sessionStorage.getItem(CROSS_SELL_STORE) || '{}');
    } catch (e) {
        return {};
    }
}

function rememberHandles(variantId, handles) {
    if (!variantId || !handles) return;
    var map = readCrossSellStore();
    map[String(variantId)] = handles;
    try {
        sessionStorage.setItem(CROSS_SELL_STORE, JSON.stringify(map));
    } catch (e) {}
}

function rememberPageCrossSell() {
    var form = document.querySelector('form[data-type="add-to-cart-form"]');
    if (!form) return;
    var handles = form.querySelector('input[name="properties[_crosssell]"]');
    var idInput = form.querySelector('input[name="id"]');
    if (!handles || !idInput || !handles.value || !idInput.value) return;
    rememberHandles(idInput.value, handles.value.trim());
}

function escapeHtml(value) {
    return String(value || '')
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;');
}

function formatCrossSellPrice(cents) {
    if (window.wetheme && typeof window.wetheme.formatMoney === 'function') {
        return window.wetheme.formatMoney(cents);
    }
    return (Number(cents || 0) / 100).toFixed(2);
}

function handlesForCart(cart) {
    var map = readCrossSellStore();
    var handles = [];
    var inCart = {};
    (cart.items || []).forEach(function (item) {
        inCart[String(item.variant_id || item.id)] = true;
        var onLine = item.properties && item.properties._crosssell;
        if (onLine) rememberHandles(item.variant_id, onLine);
        var sku = (item.sku || '').toUpperCase();
        if (sku === 'PRS' || sku === 'PER') return;
        var list = onLine || map[String(item.variant_id)];
        if (!list) return;
        list.split(',').forEach(function (handle) {
            handle = handle.trim();
            if (handle && handles.indexOf(handle) === -1) handles.push(handle);
        });
    });
    return { handles: handles, inCart: inCart };
}

async function fillLookingForMore() {
    var wrap = document.querySelector('#cross-sell-wrapper');
    if (!wrap || wrap.dataset.crossSellSource !== 'dynamic') return;
    var list = wrap.querySelector('.cross-sell-items');
    if (!list || list.querySelector('.cross-sell-item')) return;

    var cart = await fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); });
    var found = handlesForCart(cart);
    if (!found.handles.length) {
        var items = cart.items || [];
        for (var i = 0; i < items.length; i++) {
            var sku = (items[i].sku || '').toUpperCase();
            if (sku === 'PRS' || sku === 'PER' || !items[i].handle) continue;
            var page = await fetch('/products/' + items[i].handle, { credentials: 'same-origin' }).then(function (r) {
                return r.ok ? r.text() : '';
            }).catch(function () { return ''; });
            var doc = new DOMParser().parseFromString(page, 'text/html');
            var input = doc.querySelector('input[name="properties[_crosssell]"]');
            if (input && input.value) rememberHandles(items[i].variant_id, input.value.trim());
        }
        found = handlesForCart(cart);
    }
    if (!found.handles.length) return;

    var products = await Promise.all(found.handles.map(function (handle) {
        return fetch('/products/' + handle + '.js', { credentials: 'same-origin' })
            .then(function (r) { return r.ok ? r.json() : null; })
            .then(function (product) {
                if (!product) return null;
                var variant = (product.variants || []).filter(function (v) { return v.available; })[0];
                if (!variant || !(product.featured_image || product.image)) return null;
                if (found.inCart[String(variant.id)]) return null;
                return {
                    title: product.title,
                    handle: product.handle,
                    image: product.featured_image || product.image,
                    variantId: variant.id,
                    price: formatCrossSellPrice(variant.price)
                };
            })
            .catch(function () { return null; });
    }));

    products.filter(Boolean).slice(0, 12).forEach(function (product) {
        var slide = document.createElement('div');
        slide.className = 'swiper-item cross-sell-item swiper-slide';
        slide.setAttribute('data-pid', String(product.variantId));
        slide.innerHTML =
            '<a href="/products/' + product.handle + '" class="swiper-item--link">' +
                '<img src="' + product.image + '" class="swiper-item--img" width="480" height="480" alt="">' +
                '<div class="swiper-item--meta">' +
                    '<h4 class="swiper-item--title">' + escapeHtml(product.title) + '</h4>' +
                    '<div class="swiper-item--price"><span class="money">' + product.price + '</span></div>' +
                '</div>' +
            '</a>' +
            '<button class="addToCart" data-crosssell-source="cart-drawer" type="button" data-productid="' + product.variantId + '">Add to Cart</button>';
        slide.querySelector('.addToCart').addEventListener('click', function (event) {
            event.preventDefault();
            fetch('/cart/add.js', {
                method: 'POST',
                credentials: 'same-origin',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ items: [{ id: product.variantId, quantity: 1 }] })
            }).then(function () {
                var root = document.querySelector('.right-drawer-vue');
                var vm = root && root.__vue__ && root.__vue__.$children && root.__vue__.$children[0];
                if (vm && typeof vm.fetchCart === 'function') vm.fetchCart();
            });
        });
        list.appendChild(slide);
    });

    if (list.querySelector('.cross-sell-item')) {
        document.dispatchEvent(new CustomEvent('recommendations:loaded'));
    }
}

rememberPageCrossSell();
document.addEventListener('DOMContentLoaded', rememberPageCrossSell);

var lfmTimer;
new MutationObserver(function () {
    var wrap = document.querySelector('#cross-sell-wrapper');
    if (!wrap || wrap.querySelector('.cross-sell-item') || wrap.dataset.rrLfmPending === '1') return;
    wrap.dataset.rrLfmPending = '1';
    clearTimeout(lfmTimer);
    lfmTimer = setTimeout(function () {
        fillLookingForMore().catch(function () {}).then(function () {
            if (wrap) wrap.dataset.rrLfmPending = '0';
        });
    }, 1400);
}).observe(document.documentElement, { childList: true, subtree: true });

document.addEventListener('DOMContentLoaded', function () {
    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.has('z-open-cart')) {
        urlParams.delete('z-open-cart');
        const newUrl = window.location.pathname + '?' + urlParams.toString();
        window.history.replaceState(null, '', newUrl);
        setTimeout(function () {
            window.wetheme.toggleRightDrawer('cart');
        }, 1000);
    }
});
window.addEventListener('pplrAppInitiated', function (e) {
    // check if pplr has loaded
    _SJ2[0] = "1"
    var prev_pplr_after_cart = pplr_after_cart;
    console.log("LOADED")
    window.pplr_after_cart = (cart, form) => {
        const finish = () => {
            const urlParams = new URLSearchParams(window.location.search);
            if (!urlParams.has('z-open-cart')) {
                urlParams.set('z-open-cart', '1');
                const newUrl = window.location.pathname + '?' + urlParams.toString();
                window.history.replaceState(null, '', newUrl);
            }
            prev_pplr_after_cart(cart, form)
        };

        ensureCrossSellOnAddedLine(form).then(finish, finish);
    }
})